import Model, { attr, belongsTo } from '@ember-data/model';

export default class PrescreenerQuestionModel extends Model {
  @belongsTo('practice', { async: true, inverse: null }) practice;

  @attr('boolean') showOnContactForm;
  @attr('boolean') showOnAppointmentForm;

  @attr() questions;
}
